import script from "./SiendoSocioComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SiendoSocioComponent.vue?vue&type=script&setup=true&lang=js"

import "./SiendoSocioComponent.vue?vue&type=style&index=0&id=867eed00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-867eed00"]])

export default __exports__